import Vue from 'vue'

import { baseUrl } from '@/config'

export default () => {
    Vue.axios.defaults.baseURL = baseUrl

    return Vue.axios
    /* return Vue.axios({
        baseURL: baseUrl
    }).create({
        baseURL: baseUrl,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }) */
}



// WEBPACK FOOTER //
// ./src/lib/api.js